// extracted by mini-css-extract-plugin
export default {"cta":"eG-z","disabled":"fG-z"};